<script>
    import GlobalSeacrhPanel from '@/components/global-search/GlobalSeacrhPanel.vue';
    import MultiEditPanel from '@/components/multi-edit/MultiEditPanel.vue';

    import LeftPanel from '@/components/container/LeftPanel.vue';
    import RightContainer from '@/components/container/RightContainer.vue';
    import MainConainer from '@/components/container/MainContainer.vue';

    import ButtonGlobalSearch from '@/components/left-panel/file-button/ButtonGlobalSearch.vue';
    import ButtonReturn from '@/components/left-panel/unique-buttons/ButtonReturn.vue';
    import ButtonMultiEdit from '@/components/left-panel/file-button/ButtonMultiEdit.vue';
    import ButtonSaveAll from '@/components/left-panel/file-button/ButtonSaveAll.vue';
    import ButtonReleaseAll from '@/components/left-panel/file-button/ButtonReleaseAll.vue';
    import ButtonUnreleaseAll from '@/components/left-panel/file-button/ButtonUnreleaseAll.vue';
    import ButtonParseTag from '@/components/left-panel/file-button/ButtonParseTag.vue';
    import ButtonClearTags from '@/components/left-panel/file-button/ButtonClearTags.vue';

    import ProviderName from '@/components/page-file-edit/ProviderName.vue';
    import ImageList from '@/components/page-file-edit/images/ImageList.vue';

    import { promiseAll, calculatePromise } from '@/api/default.js';
    import { deepEqual } from '@/scripts/tools.js';

    export default {
        components: {
            GlobalSeacrhPanel: GlobalSeacrhPanel,
            MultiEditPanel: MultiEditPanel,

            LeftPanel: LeftPanel,
            RightContainer: RightContainer,
            MainConainer: MainConainer,
            
            ButtonGlobalSearch: ButtonGlobalSearch,
            ButtonReturn: ButtonReturn,
            ButtonMultiEdit: ButtonMultiEdit,
            ButtonSaveAll: ButtonSaveAll,
            ButtonReleaseAll: ButtonReleaseAll,
            ButtonUnreleaseAll: ButtonUnreleaseAll,
            ButtonParseTag: ButtonParseTag,
            ButtonClearTags: ButtonClearTags,

            ProviderName: ProviderName,
            ImageList: ImageList,
        },
        async mounted() {
            this.$store.commit('IS_LOAD', true);
            await this.$store.dispatch('SET_PARAMS_IN_QUERY', this.$route.query);
            await this.$store.dispatch('CHECK_ASSET_TYPES');
            
            const promiseList = await calculatePromise([
                {dispatch: 'CHECK_FILTERS_AXIOS', commit: 'FILTERS_ADD', isArray: true},
                {dispatch: 'CHECK_TAGS_AXIOS', commit: 'TAGS', isArray: false},
                {dispatch: 'CHECK_PROMPTS_AXIOS', commit: 'PROMPTS', isArray: false}
            ]);
            await promiseAll(promiseList);

            await this.$store.dispatch('UPDATE_FILES');
            this.$store.commit('IS_LOAD', false);
        },
        watch: {
            '$route.query': {
                immediate: true,
                async handler(newValue, oldValue) {
                    if (oldValue == null) return;
                    if (deepEqual(newValue, oldValue)) return;

                    this.$store.commit('IS_LOAD', true);
                    await this.$store.dispatch('SET_PARAMS_IN_QUERY', this.$route.query);
                    await this.$store.dispatch('UPDATE_FILES');
                    this.$store.commit('IS_LOAD', false);
                }
            }
        }
    }
</script>


<template>
    <GlobalSeacrhPanel />
    <MultiEditPanel />

    <MainConainer>
        <LeftPanel>
            <ButtonSaveAll />
            <ButtonReleaseAll />
            <ButtonUnreleaseAll />
            <hr class="left-separator">
            <ButtonParseTag />
            <ButtonClearTags />
            <hr class="left-separator">
            <ButtonGlobalSearch />
            <ButtonMultiEdit />
            <hr class="left-separator">
            <ButtonReturn />
        </LeftPanel>
        <RightContainer>
            <ProviderName />
            <ImageList />
        </RightContainer>
    </MainConainer>
</template>